var BestSellers = (function (_globalSettings) {

    var $loaded = null;

    var _getBestSellers = (function (siteName, accountId) {
        if ($loaded === null) {
            $loaded = new $.Deferred();

            // Call recenlty viewed products API if user is logged in
            if(window.isAuthorized) {
                $.post('https://' + siteName + '/api/shop/shop/v5/accounts/' + accountId + '/recently').done($loaded.resolve);
            } else {
                $.get('https://' + siteName + '/api/shop/product/v5/accounts/' + accountId + '/recommendations/popularitycount?category=').done($loaded.resolve);
            }

        }
        return $loaded.promise();
    });

    var _onBestSellerClick = function () {
        api.sendFeatureUsageEvent('Post checkout', 'Post checkout: bestsellers click', '5004');
    }

    return {
        init: function ($el, useSlider) {

            var options =
            {
                dots: true,
                infinite: true,
                speed: 500,
                slidesToShow: 5,
                slidesToScroll: 1,
                lazyLoad: 'ondemand',
                autoplay: true
            };

            _getBestSellers(window.location.host, _globalSettings.AccountId).done(function (products) {
               
                if (!products || products.length === 0) {
                    return;
                }
                
                var excludedTaxonomies = ["Home>>>Food & Drink"]
                var x = products && excludedTaxonomies ? products.filter(function (p) {
                    return !Object.values(p.taxonomyTree).some(function (t) {
                        return excludedTaxonomies.includes(t);
                    });
                }) : products;

                var template = $.tmpl('best-sellers-slider', {
                    Images: x,
                    CurrencySign: _globalSettings.CurrencySign,
                    isSignedIn: window.isAuthorized
                });

                $el.html(template);
                $el.find('@bestSellersItem').click(function () { _onBestSellerClick() });
                if (useSlider) {

                    $el.find('.best-sellers-slider').slick(options);

                    $el.find('.best-sellers-slider').slick('slickNext');
                }
            });
        }
    }

})(GlobalSettings);